<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
import Vue from 'vue'
import io from "socket.io-client";
import axios from 'axios'
import { mapActions } from "vuex";

export default {
    name: 'App',
    data: () => ({
        onLine: navigator.onLine,
        checkOnline: null,
        isSubmit: false,
        infoLogin: {
            email: '',
            password: ''
        },
    }),
    created() {
        let checkLoginManager = localStorage.getItem('company_token');
        let checkLoginWorker = localStorage.getItem('worker_token');
        let basicAuth = localStorage.getItem('basic_auth');
        if (checkLoginWorker || checkLoginManager || basicAuth) {
            this.showPopupLogin = false;
        }
    },
    mounted() {
        this.tooltipList()
    },
    computed: {
        layout() {
            return this.$route.meta.layout || 'default-layout'
        },
        isLoginM() {
            return this.$store.state.managerSession.isLogin;
        },
        isLoginW() {
            return this.$store.state.workerSession.isLogin;
        }
    },
    watch: {
        isLoginM(v) {
            this.socketConnect(0, this.$store.state.managerSession.managerInfo.cws_channel);
        },
        isLoginW(v) {
            this.socketConnect(1, this.$store.state.workerSession.workerInfo.mws_channel);
        },
        onLine(v) {
            this.$store.dispatch('updateOnlineFlag', v).then(() => {
                if (v) {
                    this.$addNotification({
                        title: '通知する',
                        content: 'システムがオンラインに戻りました'
                    })
                } else {
                    this.$addNotification({
                        title: '接続が切れました',
                        color: 'warning',
                        content: 'ネットワーク接続がありません。システムはオフライン モードです。'
                    })
                }
            })
        }
    },
    methods: {
        socketConnect(type, userId) {
            Vue.prototype.$socket = io.connect(process.env.VUE_APP_SOCKET_URL, {
                withCredentials: true,
                secure: true
            })

            let dataConnect = {
                type: type,
                userId: userId
            }
            // on connect
            this.$socket.on('connect', () => {
                this.$socket.emit('user_connect', dataConnect);
            })
            this.$socket.on('notification', (data) => {
                this.$store.dispatch('setNotification', data.ws_channel).then(() => {
                })
            })
        },
        tooltipList() {
            axios.get(process.env.VUE_APP_API_URL + '/master/tooltip/list')
                .then(res => {
                    if (res.data.data) {
                        this.$store.dispatch('updateListTooltip', res.data.data)
                    }
                })
                .catch(err => { 
                    console.error(err);
                })
        }
    }
}
</script>

<style lang="scss">
@import "assets/scss/main";


body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.form-group {
    width: 100%;
}

.delete {
    display: none;
}

.modal {
    z-index: 999999999999 !important;
}

.classModal .modal-background {
    background-color: black !important;
}

.pointer {
    cursor: pointer;
}
</style>
